import { Checkbox, DataHeader, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTieredStopPay extends Layout {
    checkboxIsActive: Checkbox;
    dataheaderTieredStopPay: DataHeader;
    labelGeneral: Label;
    labelStopRates: Label;
    panelGeneral: Panel;
    panelStopRates: Panel;
    sourceTieredStopPay: DataSource;
    sourceTieredStopPayRates: DataSource;
    tableTieredStopPayRates: Table;
    textboxDeductCode: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
